import Select, { createFilter } from "react-select";
import { colors } from "../../../constants/colors";

function SearchableSelect({
  value,
  options,
  onChange,
  placeholder,
  style = {},
  addProps = {},
  altColor = null,
}) {
  const primaryColor = colors.primary;

  return (
    <Select
      isSearchable={true}
      isClearable={true}
      value={value}
      options={options}
      onChange={onChange}
      styles={{
        control: (provided) => {
          return {
            ...provided,
            border: "none",
            borderBottom: `2px solid ${altColor || primaryColor}`,
            borderRadius: "0px",
            ...style,
          };
        },
        menu: (provided) => {
          return {
            ...provided,
            zIndex: "175",
          };
        },
        menuList: (provided) => {
          return {
            ...provided,
            maxHeight: "350px",
          };
        },
      }}
      theme={(theme) => {
        return {
          ...theme,
          colors: {
            ...theme.colors,
            primary: altColor || primaryColor,
            neutral30: altColor || primaryColor,
          },
        };
      }}
      placeholder={placeholder}
      filterOption={createFilter({ ignoreAccents: false })}
      {...addProps}
    />
  );
}

export default SearchableSelect;
